<template>
    <div>
        <p @click="downloadFile" class="is-pointer">
            <span class="has-text-weight-bold">Respuesta: </span>
            {{ answer }}

            <Icon family="fa" name="fa-cloud-download-alt" />
        </p>
    </div>
</template>

<script>
// import { RepositoryFactory } from "@/services/api";
const backendApiUrl = process.env.VUE_APP_BACKEND_API_URL;

export default {
    name: "file-action-item",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            answer: "",
        };
    },
    mounted() {
        let answer = this.action.answer;
        this.answer = answer ? answer.fileName : "";
    },
    watch: {
        action: {
            deep: true,
            handler(action) {
                let answer = action.answer;
                this.answer = answer ? answer.fileName : "";
            },
        },
    },
    methods: {
        async downloadFile() {
            // let fileResponse = await RepositoryFactory.files.get({
            //     fileId: this.action.answer.fileId,
            // });
            // this.executeDownload(fileResponse.data, fileResponse.contentType);
            window.open(
                `${backendApiUrl}api/files/file/${this.action.answer.fileId}/download`,
                "_blank"
            );
        },
        // executeDownload(data, contentType) {
        //     let url = window.URL.createObjectURL(
        //         new Blob([data], { type: contentType })
        //     );
        //     const link = document.createElement("a");
        //     link.href = url;
        //     link.setAttribute("download", this.action.answer.fileName);
        //     document.body.appendChild(link);
        //     link.click();
        // },
    },
};
</script>